import React from "react";
import { Modal, Form, Input, Select, message } from "antd";
import api from "../api";

const CreateUserModal = ({ open, onCancel, onSuccess }) => {
    const [form] = Form.useForm();

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            await api.post("/users/register", values);
            message.success("Usuario creado correctamente");
            form.resetFields();
            onSuccess();
        } catch (error) {
            message.error("Error al crear usuario");
        }
    };

    return (
        <Modal
            title="Nuevo Usuario"
            open={open}
            onCancel={onCancel}
            onOk={handleOk}
            okText="Guardar"
            cancelText="Cancelar"
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="nombreUsuario"
                    label="Usuario"
                    rules={[{ required: true, message: "Por favor ingresa el nombre de usuario" }]}
                >
                    <Input placeholder="Ej. usuario1" />
                </Form.Item>

                <Form.Item
                    name="clave"
                    label="Contraseña"
                    rules={[{ required: true, message: "Por favor ingresa la contraseña" }]}
                >
                    <Input.Password placeholder="******" />
                </Form.Item>

                <Form.Item
                    name="rol"
                    label="Rol"
                    initialValue="Operador 1"
                    rules={[{ required: true, message: "Por favor selecciona el rol" }]}
                >
                    <Select>
                        <Select.Option value="Super Admin">Super Admin</Select.Option>
                        <Select.Option value="Administrador">Administrador</Select.Option>
                        <Select.Option value="Operador 1">Operador 1</Select.Option>
                        <Select.Option value="Operador 2">Operador 2</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="observacion"
                    label="Observación"
                >
                    <Input.TextArea placeholder="Observaciones adicionales..." />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CreateUserModal;
